import { Button, Stack } from '@mui/material'
import React, { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'

import { StyledRouterLink } from 'components/common/StyledRouterLink'
import Icon from 'components/Icon'
import { TestSuiteFormValues } from 'components/test-suites/forms/test-suite-form-utils'
import { getTestSuitesUrls } from 'components/test-suites/test-suites-urls-utils'
import { useTranslation } from 'hooks/use-translation'

export const EditTestSuiteFormButtons: React.FC<{
  shouldShowWarning: boolean
}> = ({ shouldShowWarning }) => {
  const { trans } = useTranslation()
  const testSuitesUrls = getTestSuitesUrls()

  const { formState } = useFormContext<TestSuiteFormValues>()

  const isDisabled = useMemo(() => {
    const { isValid, isSubmitting, isDirty } = formState

    // Only evaluate form dirty state if we are editing an existing test suite
    return !isValid || isSubmitting || !isDirty
  }, [formState])

  return (
    <Stack direction="row" spacing={2}>
      <Button
        data-testid="edit-test-suite-form-save-button"
        disabled={isDisabled}
        {...(!isDisabled &&
          shouldShowWarning && {
            startIcon: <Icon icon="solidFloppyDisk" />
          })}
        type="submit"
        variant="contained"
      >
        {trans('save')}
      </Button>
      <Button
        color="secondary"
        component={StyledRouterLink}
        to={testSuitesUrls.base()}
        variant="contained"
      >
        {trans('cancel')}
      </Button>
    </Stack>
  )
}
